import { ANNUAL_REPORTS_TYPES } from './annualReportsTypes';

// Action Creators
export const fetchAnnualReportsRequest = (payload) => ({
  type: ANNUAL_REPORTS_TYPES.FETCH_ANNUAL_REPORTS_REQUEST,
  payload
});

export const fetchAnnualReportsSuccess = (payload) => ({
  type: ANNUAL_REPORTS_TYPES.FETCH_ANNUAL_REPORTS_SUCCESS,
  payload
});

export const fetchAnnualReportsFailure = (payload) => ({
  type: ANNUAL_REPORTS_TYPES.FETCH_ANNUAL_REPORTS_FAILURE,
  payload
});

export const clearAnnualReports = () => ({
  type: ANNUAL_REPORTS_TYPES.CLEAR_ANNUAL_REPORTS
});